module.exports = __webpack_public_path__ + "static/media/logo-instagram.831e8fd5.svg";